var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#calendar_svg__a)",
  fill: "#544F5A"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.437.888h-.444V.444a.444.444 0 1 0-.888 0v.444H3.552V.444a.444.444 0 1 0-.888 0v.444H2.22A2.223 2.223 0 0 0 0 3.108v5.329a2.223 2.223 0 0 0 2.22 2.22h6.217a2.223 2.223 0 0 0 2.22-2.22V3.108a2.223 2.223 0 0 0-2.22-2.22ZM.888 3.108A1.332 1.332 0 0 1 2.22 1.776h6.217a1.332 1.332 0 0 1 1.332 1.332v.444H.889v-.444Zm7.549 6.66H2.22A1.332 1.332 0 0 1 .888 8.438V4.44h8.88v3.997a1.332 1.332 0 0 1-1.331 1.332Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.328 7.327a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332ZM3.108 7.327a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332ZM7.549 7.327a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10.657v10.657H0z"
})))));
export default SvgCalendar;